import React from 'react';
import {Box, keyframes, Typography} from '@mui/material';
import {styled} from '@mui/material/styles';
import useSystemTheme from 'src/hooks/useSystemTheme.js';
import {staticImages} from "../../assets/images";

// Keyframe animations for the loading dots
const fadeInOut = keyframes`
    0%, 80%, 100% {
        opacity: 0.3;
        transform: scale(0.8);
    }
    40% {
        opacity: 1;
        transform: scale(1);
    }
`;

const LoadingContainer = styled(Box)(({isDark}) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '100vh',
    gap: '8px',
    backgroundColor: isDark ? '#050406' : '#ffffff',
    transition: 'background-color 0.3s ease',
}));

const DotsContainer = styled(Box)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px',
    marginBottom: '24px',
});

const Dot = styled(Box)(({isDark, delay}) => ({
    width: '20px',
    height: '20px',
    borderRadius: '50%',
    backgroundColor: isDark ? '#ffffff' : 'rgba(0, 20, 137, 1)',
    animation: `${fadeInOut} 1.4s infinite ease-in-out`,
    animationDelay: `${delay}s`,
    transition: 'background-color 0.3s ease',
}));

const CenterDot = styled(Box)(({isDark}) => ({
    width: '35px',
    height: '35px',
    borderRadius: '50%',
    backgroundColor: isDark ? '#ffffff' : 'rgba(0, 20, 137, 1)',
    animation: `${fadeInOut} 1.4s infinite ease-in-out`,
    animationDelay: '0.2s',
    transition: 'background-color 0.3s ease',
}));

const LoadingText = styled(Typography)(({isDark}) => ({
    fontSize: '18px',
    fontWeight: 500,
    color: isDark ? '#ffffff' : 'rgba(0, 20, 137, 1)',
    letterSpacing: '0.5px',
    transition: 'color 0.3s ease',
}));

const AppLoading = () => {
    const {isDarkMode} = useSystemTheme();

    return (
        <>
            <LoadingContainer isDark={isDarkMode}>
                <StyledImage src={staticImages.appLogo} height={170}/>
                <DotsContainer>
                    <Dot isDark={isDarkMode} delay={0}/>
                    <Dot isDark={isDarkMode} delay={0.1}/>
                    <CenterDot isDark={isDarkMode}/>
                    <Dot isDark={isDarkMode} delay={0.3}/>
                    <Dot isDark={isDarkMode} delay={0.4}/>
                </DotsContainer>
                <LoadingText isDark={isDarkMode}>
                    Please Wait
                </LoadingText>
            </LoadingContainer>
        </>
    );
};

const StyledImage = styled('img')(
    () => `
      width: auto;
      object-fit: cover;
      margin-bottom: 30px;
`
)

export default AppLoading;